
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as QGpzLWpvZGEvY29yZQ from '@js-joda/core';
import * as d2FzbTpqcy1zdHJpbmc from './ride-pooling-app-composeApp.js-builtins.mjs';

const wasmJsTag = WebAssembly.JSTag;
const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

// Placed here to give access to it from externals (js_code)
let wasmExports;
let require;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    const module = await import(/* webpackIgnore: true */'node:module');
    const importMeta = import.meta;
    require = module.default.createRequire(importMeta.url);
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const _ref_Li9za2lrby5tanM_ = Li9za2lrby5tanM;
const _ref_Li9za2lrby5tanM_c2tpa29BcGk = Li9za2lrby5tanM.skikoApi;
const _ref_QGpzLWpvZGEvY29yZQ_ = QGpzLWpvZGEvY29yZQ;

const cachedJsObjects = new WeakMap();
function getCachedJsObject(ref, ifNotCached) {
    if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
    const cached = cachedJsObjects.get(ref);
    if (cached !== void 0) return cached;
    cachedJsObjects.set(ref, ifNotCached);
    return ifNotCached;
}

const js_code = {
    'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
    'kotlin.wasm.internal.jsThrow' : wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
    'kotlin.wasm.internal.getJsEmptyString' : () => '',
    'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
    'kotlin.wasm.internal.externrefToDouble' : (ref) => Number(ref),
    'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
    'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
    'kotlin.wasm.internal.externrefHashCode' : 
    (() => {
    const dataView = new DataView(new ArrayBuffer(8));
    function numberHashCode(obj) {
        if ((obj | 0) === obj) {
            return obj | 0;
        } else {
            dataView.setFloat64(0, obj, true);
            return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
        }
    }

    const hashCodes = new WeakMap();
    function getObjectHashCode(obj) {
        const res = hashCodes.get(obj);
        if (res === undefined) {
            const POW_2_32 = 4294967296;
            const hash = (Math.random() * POW_2_32) | 0;
            hashCodes.set(obj, hash);
            return hash;
        }
        return res;
    }

    function getStringHashCode(str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            var code  = str.charCodeAt(i);
            hash  = (hash * 31 + code) | 0;
        }
        return hash;
    }

    return (obj) => {
        if (obj == null) {
            return 0;
        }
        switch (typeof obj) {
            case "object":
            case "function":
                return getObjectHashCode(obj);
            case "number":
                return numberHashCode(obj);
            case "boolean":
                return obj ? 1231 : 1237;
            default:
                return getStringHashCode(String(obj)); 
        }
    }
    })(),
    'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
    'kotlin.wasm.internal.intToExternref' : (x) => x,
    'kotlin.wasm.internal.getJsTrue' : () => true,
    'kotlin.wasm.internal.getJsFalse' : () => false,
    'kotlin.wasm.internal.kotlinUIntToJsNumberUnsafe' : (x) => x >>> 0,
    'kotlin.wasm.internal.kotlinULongToJsBigIntUnsafe' : (x) => x & 0xFFFFFFFFFFFFFFFFn,
    'kotlin.wasm.internal.newJsArray' : () => [],
    'kotlin.wasm.internal.jsArrayPush' : (array, element) => { array.push(element); },
    'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
    'kotlin.wasm.internal.itoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa32_$external_fun' : (p0) => String(p0),
    'kotlin.js.jsCatch' : (f) => { 
        let result = null;
        try { 
            f();
        } catch (e) {
           result = e;
        }
        return result;
         },
    'kotlin.js.__convertKotlinClosureToJsClosure_(()->Unit)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Unit)'](f, )),
    'kotlin.js.jsThrow' : (e) => { throw e; },
    'kotlin.io.printlnImpl' : (message) => console.log(message),
    'kotlin.io.printError' : (error) => console.error(error),
    'kotlin.js.jsArrayGet' : (array, index) => array[index],
    'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
    'kotlin.js.JsArray_$external_fun' : () => new Array(),
    'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
    'kotlin.js.stackPlaceHolder_js_code' : () => (''),
    'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
    'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
    'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
    'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
    'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
    'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
    'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
    'kotlin.js.JsString_$external_class_get' : () => JsString,
    'kotlin.js.Promise_$external_fun' : (p0) => new Promise(p0),
    'kotlin.js.__callJsClosure_((Js?)->Unit)' : (f, p0) => f(p0),
    'kotlin.js.__callJsClosure_((Js)->Unit)' : (f, p0) => f(p0),
    'kotlin.js.__convertKotlinClosureToJsClosure_((((Js?)->Unit),((Js)->Unit))->Unit)' : (f) => getCachedJsObject(f, (p0, p1) => wasmExports['__callFunction_((((Js?)->Unit),((Js)->Unit))->Unit)'](f, p0, p1)),
    'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
    'kotlin.js.__convertKotlinClosureToJsClosure_((Js?)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Js?)'](f, p0)),
    'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
    'kotlin.js.__convertKotlinClosureToJsClosure_((Js)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Js?)'](f, p0)),
    'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
    'kotlin.js.Promise_$external_class_instanceof' : (x) => x instanceof Promise,
    'kotlin.js.Promise_$external_class_get' : () => Promise,
    'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
    'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
    'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
    'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
    'kotlin.time.Date_$external_fun' : () => new Date(),
    'kotlin.time.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
    'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
    'kotlin.time.dateNow' : () => Date.now(),
    'kotlin.uuid.cryptoGetRandomValues' : (size) => crypto.getRandomValues(new Int8Array(size)),
    'kotlin.uuid.get' : (array, index) => array[index],
    'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
    'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
    'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
    'kotlinx.coroutines.error_$external_fun' : (_this, p0) => _this.error(p0),
    'kotlinx.coroutines.console_$external_prop_getter' : () => console,
    'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
    'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
    'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
    'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
        const handler = (event) => {
            if (event.source == window && event.data == 'dispatchCoroutine') {
                event.stopPropagation();
                process();
            }
        }
        window.addEventListener('message', handler, true);
    },
    'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
    'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
    'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
    'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
    'kotlinx.coroutines.promiseSetDeferred' : (promise, deferred) => promise.deferred = deferred,
    'org.khronos.webgl.setMethodImplForInt8Array' : (obj, index, value) => { obj[index] = value; },
    'org.khronos.webgl.getMethodImplForUint8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.Int8Array_$external_fun' : (p0) => new Int8Array(p0),
    'org.khronos.webgl.Int8Array_$external_fun_1' : (p0, p1, p2, isDefault0, isDefault1) => new Int8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter' : (_this) => _this.length,
    'org.khronos.webgl.slice_$external_fun' : (_this, p0, p1, isDefault0) => _this.slice(p0, isDefault0 ? undefined : p1, ),
    'org.khronos.webgl.Uint8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Uint8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter_1' : (_this) => _this.length,
    'org.khronos.webgl.buffer_$external_prop_getter' : (_this) => _this.buffer,
    'org.khronos.webgl.byteOffset_$external_prop_getter' : (_this) => _this.byteOffset,
    'org.khronos.webgl.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
    'org.khronos.webgl.buffer_$external_prop_getter_1' : (_this) => _this.buffer,
    'org.w3c.dom.clipboard.clipboardData_$external_prop_getter' : (_this) => _this.clipboardData,
    'org.w3c.dom.clipboard.ClipboardEvent_$external_class_instanceof' : (x) => x instanceof ClipboardEvent,
    'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
    'org.w3c.dom.css.display_$external_prop_setter' : (_this, v) => _this.display = v,
    'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
    'org.w3c.dom.css.minHeight_$external_prop_setter' : (_this, v) => _this.minHeight = v,
    'org.w3c.dom.css.opacity_$external_prop_setter' : (_this, v) => _this.opacity = v,
    'org.w3c.dom.css.outline_$external_prop_setter' : (_this, v) => _this.outline = v,
    'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
    'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
    'org.w3c.dom.css.visibility_$external_prop_setter' : (_this, v) => _this.visibility = v,
    'org.w3c.dom.css.whiteSpace_$external_prop_setter' : (_this, v) => _this.whiteSpace = v,
    'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.css.zIndex_$external_prop_setter' : (_this, v) => _this.zIndex = v,
    'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
    'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
    'org.w3c.dom.events.timeStamp_$external_prop_getter' : (_this) => _this.timeStamp,
    'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
    'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
    'org.w3c.dom.events.Event_$external_class_get' : () => Event,
    'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
    'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
    'org.w3c.dom.events.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
    'org.w3c.dom.events.keyCode_$external_prop_getter' : (_this) => _this.keyCode,
    'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
    'org.w3c.dom.events.KeyboardEvent_$external_class_get' : () => KeyboardEvent,
    'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
    'org.w3c.dom.events.__convertKotlinClosureToJsClosure_((Js)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Unit)'](f, p0)),
    'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.addEventListener_$external_fun_2' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun_1' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
    'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
    'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
    'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
    'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
    'org.w3c.dom.events.MouseEvent_$external_class_instanceof' : (x) => x instanceof MouseEvent,
    'org.w3c.dom.events.MouseEvent_$external_class_get' : () => MouseEvent,
    'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
    'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
    'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_get' : () => WheelEvent,
    'org.w3c.dom.events.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.events.CompositionEvent_$external_class_instanceof' : (x) => x instanceof CompositionEvent,
    'org.w3c.dom.events.CompositionEvent_$external_class_get' : () => CompositionEvent,
    'org.w3c.dom.ShadowRootInit' : (mode) => ({ mode: mode }),
    'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => ({ passive: passive, once: once, capture: capture }),
    'org.w3c.dom.location_$external_prop_getter' : (_this) => _this.location,
    'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
    'org.w3c.dom.innerHeight_$external_prop_getter' : (_this) => _this.innerHeight,
    'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
    'org.w3c.dom.open_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.open(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
    'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
    'org.w3c.dom.__convertKotlinClosureToJsClosure_((Double)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Double)->Unit)'](f, p0)),
    'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
    'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
    'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
    'org.w3c.dom.MediaQueryList_$external_class_instanceof' : (x) => x instanceof MediaQueryList,
    'org.w3c.dom.MediaQueryList_$external_class_get' : () => MediaQueryList,
    'org.w3c.dom.protocol_$external_prop_getter' : (_this) => _this.protocol,
    'org.w3c.dom.tabIndex_$external_prop_setter' : (_this, v) => _this.tabIndex = v,
    'org.w3c.dom.innerText_$external_prop_setter' : (_this, v) => _this.innerText = v,
    'org.w3c.dom.offsetWidth_$external_prop_getter' : (_this) => _this.offsetWidth,
    'org.w3c.dom.offsetHeight_$external_prop_getter' : (_this) => _this.offsetHeight,
    'org.w3c.dom.click_$external_fun' : (_this, ) => _this.click(),
    'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
    'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
    'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
    'org.w3c.dom.HTMLElement_$external_class_get' : () => HTMLElement,
    'org.w3c.dom.dropEffect_$external_prop_setter' : (_this, v) => _this.dropEffect = v,
    'org.w3c.dom.setDragImage_$external_fun' : (_this, p0, p1, p2) => _this.setDragImage(p0, p1, p2),
    'org.w3c.dom.getData_$external_fun' : (_this, p0) => _this.getData(p0),
    'org.w3c.dom.setData_$external_fun' : (_this, p0, p1) => _this.setData(p0, p1),
    'org.w3c.dom.getItem_$external_fun' : (_this, p0) => _this.getItem(p0),
    'org.w3c.dom.setItem_$external_fun' : (_this, p0, p1) => _this.setItem(p0, p1),
    'org.w3c.dom.Storage_$external_class_instanceof' : (x) => x instanceof Storage,
    'org.w3c.dom.Storage_$external_class_get' : () => Storage,
    'org.w3c.dom.key_$external_prop_getter' : (_this) => _this.key,
    'org.w3c.dom.StorageEvent_$external_class_instanceof' : (x) => x instanceof StorageEvent,
    'org.w3c.dom.protocol_$external_prop_getter_1' : (_this) => _this.protocol,
    'org.w3c.dom.binaryType_$external_prop_setter' : (_this, v) => _this.binaryType = v,
    'org.w3c.dom.close_$external_fun' : (_this, p0, p1, isDefault0, isDefault1) => _this.close(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
    'org.w3c.dom.send_$external_fun' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.send_$external_fun_1' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.Companion_$external_object_getInstance' : () => ({}),
    'org.w3c.dom.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.reason_$external_prop_getter' : (_this) => _this.reason,
    'org.w3c.dom.caches_$external_prop_getter' : (_this) => _this.caches,
    'org.w3c.dom.fetch_$external_fun' : (_this, p0, p1, isDefault0) => _this.fetch(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.documentElement_$external_prop_getter' : (_this) => _this.documentElement,
    'org.w3c.dom.readyState_$external_prop_getter' : (_this) => _this.readyState,
    'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
    'org.w3c.dom.getElementById_$external_fun' : (_this, p0) => _this.getElementById(p0),
    'org.w3c.dom.namespaceURI_$external_prop_getter' : (_this) => _this.namespaceURI,
    'org.w3c.dom.localName_$external_prop_getter' : (_this) => _this.localName,
    'org.w3c.dom.id_$external_prop_setter' : (_this, v) => _this.id = v,
    'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
    'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
    'org.w3c.dom.getAttribute_$external_fun' : (_this, p0) => _this.getAttribute(p0),
    'org.w3c.dom.getAttributeNS_$external_fun' : (_this, p0, p1) => _this.getAttributeNS(p0, p1),
    'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
    'org.w3c.dom.attachShadow_$external_fun' : (_this, p0) => _this.attachShadow(p0),
    'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
    'org.w3c.dom.Element_$external_class_instanceof' : (x) => x instanceof Element,
    'org.w3c.dom.language_$external_prop_getter' : (_this) => _this.language,
    'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
    'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
    'org.w3c.dom.DragEvent_$external_class_get' : () => DragEvent,
    'org.w3c.dom.nodeName_$external_prop_getter' : (_this) => _this.nodeName,
    'org.w3c.dom.isConnected_$external_prop_getter' : (_this) => _this.isConnected,
    'org.w3c.dom.parentElement_$external_prop_getter' : (_this) => _this.parentElement,
    'org.w3c.dom.childNodes_$external_prop_getter' : (_this) => _this.childNodes,
    'org.w3c.dom.textContent_$external_prop_setter' : (_this, v) => _this.textContent = v,
    'org.w3c.dom.lookupPrefix_$external_fun' : (_this, p0) => _this.lookupPrefix(p0),
    'org.w3c.dom.insertBefore_$external_fun' : (_this, p0, p1) => _this.insertBefore(p0, p1),
    'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
    'org.w3c.dom.removeChild_$external_fun' : (_this, p0) => _this.removeChild(p0),
    'org.w3c.dom.Node_$external_class_instanceof' : (x) => x instanceof Node,
    'org.w3c.dom.Node_$external_class_get' : () => Node,
    'org.w3c.dom.children_$external_prop_getter' : (_this) => _this.children,
    'org.w3c.dom.Companion_$external_object_getInstance_1' : () => ({}),
    'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
    'org.w3c.dom.append_$external_fun' : (_this, p0) => _this.append(...p0),
    'org.w3c.dom.item_$external_fun_1' : (_this, p0) => _this.item(p0),
    'org.w3c.dom.identifier_$external_prop_getter' : (_this) => _this.identifier,
    'org.w3c.dom.clientX_$external_prop_getter' : (_this) => _this.clientX,
    'org.w3c.dom.clientY_$external_prop_getter' : (_this) => _this.clientY,
    'org.w3c.dom.Touch_$external_class_instanceof' : (x) => x instanceof Touch,
    'org.w3c.dom.Touch_$external_class_get' : () => Touch,
    'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
    'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
    'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
    'org.w3c.dom.Companion_$external_object_getInstance_2' : () => ({}),
    'org.w3c.dom.HTMLDivElement_$external_class_instanceof' : (x) => x instanceof HTMLDivElement,
    'org.w3c.dom.HTMLDivElement_$external_class_get' : () => HTMLDivElement,
    'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
    'org.w3c.dom.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_instanceof' : (x) => x instanceof HTMLTextAreaElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_get' : () => HTMLTextAreaElement,
    'org.w3c.dom.targetTouches_$external_prop_getter' : (_this) => _this.targetTouches,
    'org.w3c.dom.changedTouches_$external_prop_getter' : (_this) => _this.changedTouches,
    'org.w3c.dom.TouchEvent_$external_class_instanceof' : (x) => x instanceof TouchEvent,
    'org.w3c.dom.TouchEvent_$external_class_get' : () => TouchEvent,
    'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
    'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
    'org.w3c.dom.MediaQueryListEvent_$external_class_get' : () => MediaQueryListEvent,
    'org.w3c.dom.parsing.DOMParser_$external_fun' : () => new DOMParser(),
    'org.w3c.dom.parsing.parseFromString_$external_fun' : (_this, p0, p1) => _this.parseFromString(p0, p1),
    'org.w3c.fetch.status_$external_prop_getter' : (_this) => _this.status,
    'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
    'org.w3c.fetch.statusText_$external_prop_getter' : (_this) => _this.statusText,
    'org.w3c.fetch.headers_$external_prop_getter' : (_this) => _this.headers,
    'org.w3c.fetch.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.fetch.clone_$external_fun' : (_this, ) => _this.clone(),
    'org.w3c.fetch.blob_$external_fun' : (_this, ) => _this.blob(),
    'org.w3c.fetch.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.w3c.fetch.Companion_$external_object_getInstance' : () => ({}),
    'org.w3c.files.slice_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.slice(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
    'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
    'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
    'org.w3c.workers.CacheQueryOptions_js_code' : (ignoreSearch, ignoreMethod, ignoreVary, cacheName) => ({ ignoreSearch: ignoreSearch, ignoreMethod: ignoreMethod, ignoreVary: ignoreVary, cacheName: cacheName }),
    'org.w3c.workers.match_$external_fun' : (_this, p0, p1, isDefault0) => _this.match(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.workers.put_$external_fun' : (_this, p0, p1) => _this.put(p0, p1),
    'org.w3c.workers.open_$external_fun' : (_this, p0) => _this.open(p0),
    'org.w3c.workers.delete_$external_fun' : (_this, p0) => _this.delete(p0),
    'org.w3c.xhr.XMLHttpRequest_$external_fun' : () => new XMLHttpRequest(),
    'org.w3c.xhr.status_$external_prop_getter' : (_this) => _this.status,
    'org.w3c.xhr.open_$external_fun' : (_this, p0, p1, p2, p3, p4, isDefault0, isDefault1) => _this.open(p0, p1, p2, isDefault0 ? undefined : p3, isDefault1 ? undefined : p4, ),
    'org.w3c.xhr.send_$external_fun' : (_this, ) => _this.send(),
    'org.w3c.xhr.overrideMimeType_$external_fun' : (_this, p0) => _this.overrideMimeType(p0),
    'kotlinx.browser.window_$external_prop_getter' : () => window,
    'kotlinx.browser.sessionStorage_$external_prop_getter' : () => sessionStorage,
    'kotlinx.browser.localStorage_$external_prop_getter' : () => localStorage,
    'kotlinx.browser.document_$external_prop_getter' : () => document,
    'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
    'org.w3c.dom.item_$external_fun_2' : (_this, p0) => _this.item(p0),
    'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.jetbrains.skiko.GL_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.GL,
    'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
    'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
    'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_c2tpa29BcGk._releaseLocalCallbackScope(),
    'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
    'org.jetbrains.skiko.wasm.createDefaultContextAttributes' : () => {
        return {
            alpha: 1,
            depth: 1,
            stencil: 8,
            antialias: 0,
            premultipliedAlpha: 1,
            preserveDrawingBuffer: 0,
            preferLowPowerToHighPerformance: 0,
            failIfMajorPerformanceCaveat: 0,
            enableExtensionsByDefault: 1,
            explicitSwapControl: 0,
            renderViaOffscreenBackBuffer: 0,
            majorVersion: 2,
        }
    }
    ,
    'org.jetbrains.skiko.wasm.awaitSkiko_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.awaitSkiko,
    'org.jetbrains.skiko.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
    'org.jetbrains.skiko.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
    'org.jetbrains.skiko.w3c.language_$external_prop_getter' : (_this) => _this.language,
    'org.jetbrains.skiko.w3c.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
    'org.jetbrains.skiko.w3c.navigator_$external_prop_getter' : (_this) => _this.navigator,
    'org.jetbrains.skiko.w3c.performance_$external_prop_getter' : (_this) => _this.performance,
    'org.jetbrains.skiko.w3c.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
    'org.jetbrains.skiko.w3c.open_$external_fun' : (_this, p0, p1) => _this.open(p0, p1),
    'org.jetbrains.skiko.w3c.window_$external_object_getInstance' : () => window,
    'org.jetbrains.skiko.w3c.now_$external_fun' : (_this, ) => _this.now(),
    'org.jetbrains.skiko.w3c.width_$external_prop_getter' : (_this) => _this.width,
    'org.jetbrains.skiko.w3c.height_$external_prop_getter' : (_this) => _this.height,
    'org.jetbrains.skiko.w3c.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
    'org.jetbrains.skiko.w3c.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
    'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
    'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
    'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
    'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
    'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
    'androidx.compose.ui.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.ui.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.ui.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.ui.platform.createClipboardItemWithPlainText' : (text) => [new ClipboardItem({'text/plain': new Blob([text], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.emptyClipboardItems' : () => [new ClipboardItem({'text/plain': new Blob([''], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.invalidClipboardItems' : () => [],
    'androidx.compose.ui.platform.warn' : (text) => { console.warn(text) },
    'androidx.compose.ui.platform.types_$external_prop_getter' : (_this) => _this.types,
    'androidx.compose.ui.platform.getType_$external_fun' : (_this, p0) => _this.getType(p0),
    'androidx.compose.ui.platform.read_$external_fun' : (_this, ) => _this.read(),
    'androidx.compose.ui.platform.write_$external_fun' : (_this, p0) => _this.write(p0),
    'androidx.compose.ui.platform.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_instanceof' : (x) => x instanceof Clipboard,
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_get' : () => Clipboard,
    'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
    'androidx.compose.ui.events.withSignal' : (signal) => ({signal: signal}),
    'androidx.compose.ui.events.AbortController_$external_fun' : () => new AbortController(),
    'androidx.compose.ui.events.signal_$external_prop_getter' : (_this) => _this.signal,
    'androidx.compose.ui.internal.focusExt' : (element, _preventScroll) => element.focus({ preventScroll: _preventScroll }),
    'androidx.compose.ui.platform.setBackingInputBox' : (container, left, top, width, height) => { 
        container.style.setProperty("--compose-internal-web-backing-input-left", left);
        container.style.setProperty("--compose-internal-web-backing-input-top", top);
        container.style.setProperty("--compose-internal-web-backing-input-width", width);
        container.style.setProperty("--compose-internal-web-backing-input-height", height)
     },
    'androidx.compose.ui.platform.isTypedEvent' : (evt) => !evt.metaKey && !evt.ctrlKey && evt.key.charAt(0) === evt.key,
    'androidx.compose.ui.platform.value_$external_prop_setter' : (_this, v) => _this.value = v,
    'androidx.compose.ui.platform.selectionStart_$external_prop_getter' : (_this) => _this.selectionStart,
    'androidx.compose.ui.platform.selectionEnd_$external_prop_getter' : (_this) => _this.selectionEnd,
    'androidx.compose.ui.platform.setSelectionRange_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setSelectionRange(p0, p1, isDefault0 ? undefined : p2, ),
    'androidx.compose.ui.platform.inputType_$external_prop_getter' : (_this) => _this.inputType,
    'androidx.compose.ui.platform.data_$external_prop_getter' : (_this) => _this.data,
    'androidx.compose.ui.platform.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_getter' : (_this) => _this.textRangeStart,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_setter' : (_this, v) => _this.textRangeStart = v,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_getter' : (_this) => _this.textRangeEnd,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_setter' : (_this, v) => _this.textRangeEnd = v,
    'androidx.compose.ui.platform.InputEvent_$external_class_instanceof' : (x) => x instanceof InputEvent,
    'androidx.compose.ui.platform.InputEvent_$external_class_get' : () => InputEvent,
    'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext === true,
    'androidx.compose.ui.platform.isFullClipboardApiSupported' : () => Boolean(
            window.navigator.clipboard && 
            window.navigator.clipboard.write && 
            window.navigator.clipboard.read && 
            typeof(ClipboardItem) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.isFallbackWriteTextApiAvailable' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.writeText),
    'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
    'androidx.compose.ui.platform.accessibility.removeAllChildrenOf' : (element) => { element.replaceChildren() },
    'androidx.compose.ui.platform.accessibility.setA11YAriaRole' : (element, ariaRoleId) => { 
            var roleValue = "";
            switch (ariaRoleId) {
                case 0: // Role.Button
                    roleValue = "button";
                    break;
                case 1: // Role.Checkbox
                    roleValue = "checkbox";
                    break;
                case 2: // Role.Switch
                    roleValue = "switch";
                    break;
                case 3: // Role.RadioButton
                    roleValue = "radio";
                    break;
                case 4: // Role.Tab
                    roleValue = "tab";
                    break;
                case 5: // Role.Image
                    roleValue = "img";
                    break;
                case 6: // Role.DropdownList
                    roleValue = "menu";
                    break;
                case 7: // heading https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/heading_role
                    roleValue = "heading";
                    break;
                case 8: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/textbox_role
                    roleValue = "textbox";
                    break;
                case 9: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/list_role
                    roleValue = "list";
                    break;
                case 10: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/grid_role
                    roleValue = "grid";
                    break;
                default:
                    break;
            }
            if (roleValue.length > 0) { 
                element.setAttribute("role", roleValue);
            } else {
                element.removeAttribute("role");
            }
         },
    'androidx.compose.ui.platform.accessibility.setSizeAndPosition' : (element, left, top, width, height) => { 
           element.style.left = "" + left + "px";
           element.style.top = "" + top + "px";
           element.style.width = "" + width + "px";
           element.style.height = "" + height + "px";
         },
    'androidx.compose.ui.viewinterop.toggleVisibility' : (element, isHidden) => { 
           element.style.visibility = isHidden ? "hidden" : "visible";
         },
    'androidx.compose.ui.viewinterop.setSizeAndPosition' : (element, left, top, width, height) => { 
           element.style.left = "" + left + "px";
           element.style.top = "" + top + "px";
           element.style.width = "" + width + "px";
           element.style.height = "" + height + "px";
         },
    'androidx.compose.ui.viewinterop.setClipPath' : (element, top, right, bottom, left) => { 
           element.style.setProperty("clip-path", "inset(" + top + "px " + right + "px " + bottom + "px " + left + "px)"); 
         },
    'androidx.compose.ui.window.documentIsVisible' : () => document.visibilityState === 'visible',
    'androidx.compose.ui.window.force_$external_prop_getter' : (_this) => _this.force,
    'androidx.compose.foundation.internal.isClipboardWriteSupported' : () => Boolean(window.navigator.clipboard && (window.navigator.clipboard.write || window.navigator.clipboard.writeText)),
    'androidx.compose.foundation.internal.isClipboardReadSupported' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.read),
    'androidx.compose.foundation.internal.getTextFromBlob' : (blob) => blob.text(),
    'androidx.compose.foundation.internal.doesJsArrayContainValue' : (jsArray, value) => jsArray.includes(value),
    'androidx.compose.foundation.text.EventListener' : (handler) => (event) => { handler(event) },
    'org.jetbrains.compose.resources.Locale_$external_fun' : (p0) => new Intl.Locale(p0),
    'org.jetbrains.compose.resources.language_$external_prop_getter' : (_this) => _this.language,
    'org.jetbrains.compose.resources.region_$external_prop_getter' : (_this) => _this.region,
    'org.jetbrains.compose.resources.isInTestEnvironment' : () => window.composeResourcesTesting == true,
    'org.jetbrains.compose.resources.requestResponseAsByteArray' : (req) =>  {
            var text = req.responseText;
            var int8Arr = new Int8Array(text.length);
            for (var i = 0; i < text.length; i++) {
                int8Arr[i] = text.charCodeAt(i) & 0xFF;
            }
            return int8Arr;
        },
    'org.jetbrains.compose.resources.jsExportInt8ArrayToWasm' :  (src, size, dstAddr) => {
            const mem8 = new Int8Array(wasmExports.memory.buffer, dstAddr, size);
            mem8.set(src);
        }
    ,
    'org.jetbrains.compose.resources.jsExportBlobAsArrayBuffer' : (blob) => blob.arrayBuffer(),
    'org.jetbrains.compose.resources.supportsCacheApi' : () => Boolean(window.caches),
    'kotlinx.io.node.sep_$external_prop_getter' : (_this) => _this.sep,
    'kotlinx.io.node.requireExists' : () => typeof require === 'function',
    'kotlinx.io.node.requireModule' : (mod) => {
         try {
             let m = require(mod);
             if (m) return m;
             return null;
         } catch (e) {
             return null;
         }
     },
    'io.ktor.utils.io.js.decode' : (decoder, buffer) => { try { return decoder.decode(buffer) } catch(e) { return null } },
    'io.ktor.utils.io.js.tryCreateTextDecoder' : (encoding, fatal) => { try { return new TextDecoder(encoding, { fatal: fatal }) } catch(e) { return null } },
    'io.ktor.utils.io.charsets.toJsArrayImpl' : (x) => new Int8Array(x),
    'io.ktor.util.hasNodeApi' : () => 
    (typeof process !== 'undefined' 
        && process.versions != null 
        && process.versions.node != null) ||
    (typeof window !== 'undefined' 
        && typeof window.process !== 'undefined' 
        && window.process.versions != null 
        && window.process.versions.node != null)
    ,
    'io.ktor.util.logging.getKtorLogLevel' : () => process ? process.env.KTOR_LOG_LEVEL : null,
    'io.ktor.util.logging.warn_$external_fun' : (_this, p0) => _this.warn(p0),
    'io.ktor.util.logging.debug_$external_fun' : (_this, p0) => _this.debug(p0),
    'io.ktor.util.logging.console_$external_prop_getter' : () => console,
    'io.ktor.util.date.Date_$external_fun' : () => new Date(),
    'io.ktor.util.date.Date_$external_fun_1' : (p0) => new Date(p0),
    'io.ktor.util.date.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'io.ktor.util.date.getUTCDate_$external_fun' : (_this, ) => _this.getUTCDate(),
    'io.ktor.util.date.getUTCDay_$external_fun' : (_this, ) => _this.getUTCDay(),
    'io.ktor.util.date.getUTCFullYear_$external_fun' : (_this, ) => _this.getUTCFullYear(),
    'io.ktor.util.date.getUTCHours_$external_fun' : (_this, ) => _this.getUTCHours(),
    'io.ktor.util.date.getUTCMinutes_$external_fun' : (_this, ) => _this.getUTCMinutes(),
    'io.ktor.util.date.getUTCMonth_$external_fun' : (_this, ) => _this.getUTCMonth(),
    'io.ktor.util.date.getUTCSeconds_$external_fun' : (_this, ) => _this.getUTCSeconds(),
    'io.ktor.util.date.UTC_$external_fun' : (_this, p0, p1, p2, p3, p4, p5) => _this.UTC(p0, p1, p2, p3, p4, p5),
    'io.ktor.util.date.Companion_$external_object_getInstance' : () => Date,
    'io.ktor.http.locationOrigin' : () => function() {
        var tmpLocation = null
        if (typeof window !== 'undefined') {
          tmpLocation = window.location
        } else if (typeof self !== 'undefined') {
          tmpLocation = self.location
        }
        var origin = ""
        if (tmpLocation) {
          origin = tmpLocation.origin
        }
        return origin && origin != "null" ? origin : "http://localhost"    
    }(),
    'io.ktor.client.engine.js.createBrowserWebSocket' : (urlString_capturingHack, protocols) => new WebSocket(urlString_capturingHack, protocols),
    'io.ktor.client.engine.js.createWebSocketNodeJs' : (socketCtor, urlString_capturingHack, headers_capturingHack, protocols) => new socketCtor(urlString_capturingHack, protocols, { headers: headers_capturingHack }),
    'io.ktor.client.engine.js.getKeys' : (headers) => Array.from(headers.keys()),
    'io.ktor.client.engine.js.eventAsString' : (event) => JSON.stringify(event, ['message', 'target', 'type', 'isTrusted']),
    'io.ktor.client.engine.js.compatibility.abortControllerCtorBrowser' : () => AbortController,
    'io.ktor.client.fetch.body_$external_prop_setter' : (_this, v) => _this.body = v,
    'io.ktor.client.fetch.headers_$external_prop_setter' : (_this, v) => _this.headers = v,
    'io.ktor.client.fetch.method_$external_prop_setter' : (_this, v) => _this.method = v,
    'io.ktor.client.fetch.redirect_$external_prop_setter' : (_this, v) => _this.redirect = v,
    'io.ktor.client.fetch.signal_$external_prop_setter' : (_this, v) => _this.signal = v,
    'io.ktor.client.fetch.signal_$external_prop_getter' : (_this) => _this.signal,
    'io.ktor.client.fetch.abort_$external_fun' : (_this, ) => _this.abort(),
    'io.ktor.client.fetch.fetch_$external_fun' : (p0, p1, isDefault0) => fetch(p0, isDefault0 ? undefined : p1, ),
    'io.ktor.client.fetch.getReader_$external_fun' : (_this, ) => _this.getReader(),
    'io.ktor.client.fetch.cancel_$external_fun' : (_this, p0, isDefault0) => _this.cancel(isDefault0 ? undefined : p0, ),
    'io.ktor.client.fetch.read_$external_fun' : (_this, ) => _this.read(),
    'io.ktor.client.fetch.done_$external_prop_getter' : (_this) => _this.done,
    'io.ktor.client.fetch.value_$external_prop_getter' : (_this) => _this.value,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsString' : (data) => typeof(data) === 'string' ? data : null,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsArrayBuffer' : (data) => data instanceof ArrayBuffer ? data : null,
    'io.ktor.client.utils.makeJsObject' : () => { return {}; },
    'io.ktor.client.utils.makeImport' : (name) => import(name),
    'io.ktor.client.utils.makeJsCall' : (func, arg) => func.apply(null, arg),
    'io.ktor.client.utils.jsObjectAssign' : () => Object.assign,
    'io.ktor.client.utils.makeJsNew' : (ctor) => new ctor(),
    'io.ktor.client.utils.getObjectField' : (obj, name) => obj[name],
    'io.ktor.client.utils.setObjectField' : (obj, name, value) => obj[name]=value,
    'io.ktor.client.utils.toJsArrayImpl' : (x) => new Uint8Array(x),
    'com.rapido.foundation.time.dateNow' : () => Date.now(),
    'androidx.datastore.core.okio.getArrayBufferFromBlob' : (blob) => blob.arrayBuffer(),
    'androidx.datastore.core.okio.getInt8' : (array, index) => array[index],
    'androidx.datastore.core.okio.setInt8' : (array, index, value) => array[index] = value,
    'androidx.datastore.core.okio.getWasmOpfsRoot' : () => window.navigator.storage.getDirectory(),
    'androidx.datastore.core.okio.getWasmNavigator' : () => navigator,
    'androidx.datastore.core.okio.createWritable_$external_fun' : (_this, ) => _this.createWritable(),
    'androidx.datastore.core.okio.getFile_$external_fun' : (_this, ) => _this.getFile(),
    'androidx.datastore.core.okio.getFileHandle_$external_fun' : (_this, p0, p1, isDefault0) => _this.getFileHandle(p0, isDefault0 ? undefined : p1, ),
    'androidx.datastore.core.okio.write_$external_fun' : (_this, p0) => _this.write(p0),
    'androidx.datastore.core.okio.close_$external_fun' : (_this, ) => _this.close(),
    'androidx.datastore.core.okio.request_$external_fun' : (_this, p0, p1) => _this.request(p0, p1),
    'androidx.datastore.core.okio.__convertKotlinClosureToJsClosure_((Js?)->Js)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Js)'](f, p0)),
    'androidx.datastore.core.okio.request_$external_fun_1' : (_this, p0, p1, p2) => _this.request(p0, p1, p2),
    'androidx.datastore.core.okio.locks_$external_prop_getter' : (_this) => _this.locks,
    'androidx.datastore.core.okio.createCreateOptions' : () => ({create: true}),
    'androidx.datastore.core.okio.BroadcastChannel_$external_fun' : (p0) => new BroadcastChannel(p0),
    'androidx.datastore.core.okio.postMessage_$external_fun' : (_this, p0) => _this.postMessage(p0),
    'androidx.datastore.core.okio.close_$external_fun_1' : (_this, ) => _this.close(),
    'androidx.datastore.core.okio.onmessage_$external_prop_setter' : (_this, v) => _this.onmessage = v,
    'androidx.datastore.core.okio.tryLockOptions' : () => ({mode: 'exclusive', ifAvailable: true}),
    'co.touchlab.kermit.consoleError' : (output) => console.error(output),
    'co.touchlab.kermit.consoleWarn' : (output) => console.warn(output),
    'co.touchlab.kermit.consoleInfo' : (output) => console.info(output),
    'co.touchlab.kermit.consoleLog' : (output) => console.log(output),
    'com.rapido.thiqa.jsResultSuccess' : (xM, xKm, xEkref, xPm) => ({ success: true, xM: xM, xKm: xKm, xEkref: xEkref, xPm: xPm }),
    'com.rapido.thiqa.jsResultError' : (message) => ({ success: false, error: message }),
    'com.rapido.thiqa.internal.crypto.subtleDigest' : (algorithm, data) => crypto.subtle.digest(algorithm, data),
    'com.rapido.thiqa.internal.crypto.hmacAlgorithm' : (hash) => ({ name: 'HMAC', hash: { name: hash } }),
    'com.rapido.thiqa.internal.crypto.jsArrayOf' : (item) => [item],
    'com.rapido.thiqa.internal.crypto.subtleImportKey' : (format, keyData, algorithm, extractable, usages) => crypto.subtle.importKey(format, keyData, algorithm, extractable, usages),
    'com.rapido.thiqa.internal.crypto.subtleSign' : (algorithm, key, data) => crypto.subtle.sign(algorithm, key, data),
    'com.rapido.thiqa.internal.crypto.aesCbcAlgorithm' : (iv) => ({ name: 'AES-CBC', iv: iv }),
    'com.rapido.thiqa.internal.crypto.subtleEncrypt' : (algorithm, key, data) => crypto.subtle.encrypt(algorithm, key, data),
    'com.rapido.thiqa.internal.crypto.subtleDecrypt' : (algorithm, key, data) => crypto.subtle.decrypt(algorithm, key, data),
    'com.rapido.thiqa.internal.crypto.createUint8Array' : (size) => new Uint8Array(size),
    'com.rapido.thiqa.internal.crypto.fillRandomValues' : (array) => crypto.getRandomValues(array),
    'com.rapido.thiqa.internal.crypto.setUint8ArrayElement' : (array, index, value) => array[index] = value,
    'com.rapido.thiqa.internal.crypto.getUint8ArrayElement' : (array, index) => array[index],
    'com.rapido.thiqa.internal.crypto.newUint8ArrayFromBuffer' : (buffer) => new Uint8Array(buffer),
    'com.rapido.thiqa.internal.crypto.uint8ArrayLength' : (array) => array.length,
    'com.rapido.thiqa.internal.provider.getHostname' : () => window.location.hostname,
    'kotlinx.datetime.internal.Date_$external_fun' : (p0) => new Date(p0),
    'kotlinx.datetime.internal.getTimezoneOffset_$external_fun' : (_this, ) => _this.getTimezoneOffset(),
    'kotlinx.datetime.internal.JSJoda.ZoneRulesProvider_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneRulesProvider,
    'kotlinx.datetime.internal.JSJoda.id_$external_fun' : (_this, ) => _this.id(),
    'kotlinx.datetime.internal.JSJoda.systemDefault_$external_fun' : (_this, ) => _this.systemDefault(),
    'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneId,
    'kotlinx.datetime.internal.withCaughtJsException' : (body) => {
        try {
            body();
            return null;
        } catch(e) {
            return e;
        }
    },
    'kotlinx.datetime.internal.getExceptionMessage' : (jsException) => jsException.message,
    'kotlinx.datetime.internal.getZones' : (rulesProvider) => rulesProvider.getTzdbData().zones,
    'kotlinx.datetime.internal.getLinks' : (rulesProvider) => rulesProvider.getTzdbData().links,
    'mobi.stratus.pool.platform.isWebShareSupported' : () => (typeof navigator !== 'undefined' && typeof navigator.share === 'function'),
    'mobi.stratus.pool.platform.invokeWebShare' : (title, text) => { navigator.share({ title: title, text: text }).catch(function() {}) },
    'mobi.stratus.pool.platform.showToast' : (message) => { {
          var toast = document.createElement('div');
          toast.textContent = message;
          toast.style.cssText = 'position:fixed;left:50%;bottom:32px;transform:translateX(-50%);' +
            'background:rgba(0,0,0,0.85);color:#fff;padding:12px 20px;border-radius:24px;' +
            'font-size:14px;font-family:-apple-system,BlinkMacSystemFont,Roboto,sans-serif;' +
            'z-index:2147483647;box-shadow:0 4px 12px rgba(0,0,0,0.2);' +
            'opacity:0;transition:opacity 200ms ease;pointer-events:none;max-width:90vw;text-align:center;';
          document.body.appendChild(toast);
          requestAnimationFrame(function() { toast.style.opacity = '1'; });
          setTimeout(function() {
            toast.style.opacity = '0';
            setTimeout(function() {
              if (toast.parentNode) toast.parentNode.removeChild(toast);
            }, 250);
          }, 2200);
        } },
    'mobi.stratus.pool.platform.interop.value_$external_prop_setter' : (_this, v) => _this.value = v,
    'mobi.stratus.pool.platform.interop.style_$external_prop_getter' : (_this) => _this.style,
    'mobi.stratus.pool.platform.interop.focus_$external_fun' : (_this, ) => _this.focus(),
    'mobi.stratus.pool.platform.interop.select_$external_fun' : (_this, ) => _this.select(),
    'mobi.stratus.pool.platform.interop.body_$external_prop_getter' : (_this) => _this.body,
    'mobi.stratus.pool.platform.interop.createElement_$external_fun' : (_this, p0) => _this.createElement(p0),
    'mobi.stratus.pool.platform.interop.execCommand_$external_fun' : (_this, p0) => _this.execCommand(p0),
    'mobi.stratus.pool.platform.interop.webDocument_$external_prop_getter' : () => document,
    'mobi.stratus.pool.platform.interop.position_$external_prop_setter' : (_this, v) => _this.position = v,
    'mobi.stratus.pool.platform.interop.opacity_$external_prop_setter' : (_this, v) => _this.opacity = v,
    'mobi.stratus.pool.platform.interop.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
    'mobi.stratus.pool.platform.interop.removeChild_$external_fun' : (_this, p0) => _this.removeChild(p0),
    'mobi.stratus.pool.platform.interop.href_$external_prop_getter' : (_this) => _this.href,
    'mobi.stratus.pool.platform.interop.href_$external_prop_setter' : (_this, v) => _this.href = v,
    'mobi.stratus.pool.platform.interop.navigator_$external_prop_getter' : (_this) => _this.navigator,
    'mobi.stratus.pool.platform.interop.location_$external_prop_getter' : (_this) => _this.location,
    'mobi.stratus.pool.platform.interop.browserWindow_$external_prop_getter' : () => window,
    'mobi.stratus.pool.platform.interop.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
    'mobi.stratus.pool.platform.interop.clipboard_$external_prop_getter' : (_this) => _this.clipboard,
    'coil3.util.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'coil3.util.deref_$external_fun' : (_this, ) => _this.deref(),
    'io.github.alexzhirkevich.compottie.createSourceStable' : (data) => 
    ({
       start(c){ 
         console.log(data)
         c.enqueue(data)
         c.close()
       }
    })
    ,
    'io.github.alexzhirkevich.compottie.createSourceUnstable' : (data) => 
    ({
       start(c){ 
         const size = wasmExports.kotlinArraySize(data);
         const result = new Int8Array(size);
         for (let i = 0; i < size; i++) {
            result[i] = wasmExports.kotlinArrayGet(data, i);
         }
         c.enqueue(result)
         c.close()
       }
    })
    ,
    'io.github.alexzhirkevich.compottie.byteArrayToInt8ArrayImpl' : (a) => {
      const size = wasmExports.kotlinArraySize(a);
      const result = new Int8Array(size);
      for (let i = 0; i < size; i++) {
         result[i] = wasmExports.kotlinArrayGet(a, i);
      }
      return result;
    },
    'io.github.alexzhirkevich.compottie.jsExportInt8ArrayToWasm' :  (src, size, dstAddr) => {
            const mem8 = new Uint8Array(wasmExports.memory.buffer, dstAddr, size);
            mem8.set(src);
        }
    ,
    'io.github.alexzhirkevich.compottie.DecompressionStream_$external_fun' : (p0) => new DecompressionStream(p0),
    'io.github.alexzhirkevich.compottie.ReadableStream_$external_fun' : (p0) => new ReadableStream(p0),
    'io.github.alexzhirkevich.compottie.pipeThrough_$external_fun' : (_this, p0) => _this.pipeThrough(p0),
    'io.github.alexzhirkevich.compottie.getReader_$external_fun' : (_this, ) => _this.getReader(),
    'io.github.alexzhirkevich.compottie.read_$external_fun' : (_this, ) => _this.read(),
    'io.github.alexzhirkevich.compottie.done_$external_prop_getter' : (_this) => _this.done,
    'io.github.alexzhirkevich.compottie.value_$external_prop_getter' : (_this) => _this.value,
    'io.github.alexzhirkevich.compottie.currentTimeDouble' : () => Date.now(),
    'androidx.compose.material3.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.material3.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.material3.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.constraintlayout.core.platform.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.constraintlayout.core.platform.deref_$external_fun' : (_this, ) => _this.deref(),
    'mobi.stratus.pool.presentation.components.picker.ensureImageInput' : () => { 
        {
          if (globalThis.hoprImageInput) return;
          var input = document.createElement('input');
          input.type = 'file';
          input.accept = 'image/*';
          input.style.position = 'fixed';
          input.style.left = '-100px';
          input.style.top = '-100px';
          input.style.width = '1px';
          input.style.height = '1px';
          input.style.opacity = '0';
          input.addEventListener('change', function() {
            var picker = globalThis.hoprImagePicker;
            var file = input.files && input.files[0];
            input.value = '';
            if (!picker) return;
            if (!file) {
              picker.onError('No Image Selected');
              return;
            }
            var reader = new FileReader();
            reader.onload = function() {
              globalThis.hoprCompressPickerImage(String(reader.result || ''), file.size, picker);
            };
            reader.onerror = function() {
              picker.onError('Image Pick Failure');
            };
            reader.readAsDataURL(file);
          });
          input.addEventListener('cancel', function() {
            var picker = globalThis.hoprImagePicker;
            if (picker) picker.onError('No Image Selected');
          });
          if (document.body) document.body.appendChild(input);
          globalThis.hoprImageInput = input;

          globalThis.hoprCompressPickerImage = function(dataUrl, fileSize, picker) {
            if (!dataUrl) {
              picker.onError('Image Pick Failure');
              return;
            }
            if (fileSize <= picker.maxBytes) {
              picker.onResult(dataUrl);
              return;
            }
            var image = new Image();
            image.onload = function() {
              var canvas = document.createElement('canvas');
              var width = image.naturalWidth || image.width;
              var height = image.naturalHeight || image.height;
              var quality = 0.9;
              var attempts = 0;
              var scales = 0;
              var emit = function() {
                canvas.width = width;
                canvas.height = height;
                var ctx = canvas.getContext('2d');
                ctx.drawImage(image, 0, 0, width, height);
                var out = canvas.toDataURL('image/jpeg', quality);
                var comma = out.indexOf(',');
                var payload = comma >= 0 ? out.substring(comma + 1) : '';
                var bytes = payload.length * 3 / 4;
                if (bytes <= picker.maxBytes) {
                  picker.onResult(out);
                  return;
                }
                attempts = attempts + 1;
                quality = quality - 0.05;
                if (attempts < 5 && quality > 0.4) {
                  emit();
                  return;
                }
                if (scales < 4 && width > 320) {
                  width = Math.max(1, Math.round(width * 0.7));
                  height = Math.max(1, Math.round(height * 0.7));
                  quality = 0.85;
                  attempts = 0;
                  scales = scales + 1;
                  emit();
                  return;
                }
                picker.onError('Unable to compress image');
              };
              emit();
            };
            image.onerror = function() {
              picker.onError('Image Pick Failure');
            };
            image.src = dataUrl;
          };
        }
         },
    'mobi.stratus.pool.presentation.components.picker.removeImageInput' : () => { 
        {
          var input = globalThis.hoprImageInput;
          if (input && input.parentNode) input.parentNode.removeChild(input);
          globalThis.hoprImageInput = null;
          globalThis.hoprImagePicker = null;
        }
         },
    'mobi.stratus.pool.presentation.components.picker.installPickerCallbacks' : (maxBytes, onResult, onError) => { 
        {
          globalThis.hoprImagePicker = {
            maxBytes: maxBytes,
            onResult: onResult,
            onError: onError
          };
        }
         },
    'mobi.stratus.pool.presentation.components.picker.__convertKotlinClosureToJsClosure_((String)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((String)->Unit)'](f, p0)),
    'mobi.stratus.pool.presentation.components.picker.openImageInput' : () => { 
        {
          var input = globalThis.hoprImageInput;
          if (input) input.click();
        }
         },
    'androidx.navigation.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.navigation.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.navigation.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'mobi.stratus.pool.analytics.init_$external_fun' : (_this, p0) => _this.init(p0),
    'mobi.stratus.pool.analytics.pushEvent_$external_fun' : (_this, p0, p1) => _this.pushEvent(p0, p1),
    'mobi.stratus.pool.analytics.onUserLogin_$external_fun' : (_this, p0) => _this.onUserLogin(p0),
    'mobi.stratus.pool.analytics.CleverTapBridge_$external_object_getInstance' : () => CleverTapBridge,
    'com.rapido.maps.kmp.interop.createJsArray' : () => [],
    'com.rapido.maps.kmp.interop.createMapImpl' : 
        (element, lat, lng, zoom, tilt, bearing) => {
            var opts = {
                center: { lat: lat, lng: lng },
                zoom: zoom,
                tilt: tilt,
                heading: bearing,
                disableDefaultUI: false,
                zoomControl: true,
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: false,
                gestureHandling: 'auto'
            };
            return new google.maps.Map(element, opts);
        }
        ,
    'com.rapido.maps.kmp.interop.addCameraChangeListenerImpl' : 
        (m, cb) => {
            var emit = function() {
                var c = m.getCenter();
                if (!c) return;
                cb(c.lat(), c.lng(), m.getZoom(), m.getTilt(), m.getHeading() || 0);
            };
            google.maps.event.addListener(m, 'center_changed', emit);
            google.maps.event.addListener(m, 'zoom_changed', emit);
            google.maps.event.addListener(m, 'bounds_changed', emit);
        }
        ,
    'com.rapido.maps.kmp.interop.__convertKotlinClosureToJsClosure_((Double,Double,Float,Float,Float)->Unit)' : (f) => getCachedJsObject(f, (p0, p1, p2, p3, p4) => wasmExports['__callFunction_((Double,Double,Float,Float,Float)->Unit)'](f, p0, p1, p2, p3, p4)),
    'com.rapido.maps.kmp.interop.addCameraIdleListenerImpl' : 
        (m, cb) => {
            google.maps.event.addListener(m, 'idle', function() {
                var c = m.getCenter();
                cb(c.lat(), c.lng(), m.getZoom(), m.getTilt(), m.getHeading() || 0);
            });
        }
        ,
    'com.rapido.maps.kmp.interop.addMapLoadedListenerImpl' : 
        (m, cb) => {
            google.maps.event.addListenerOnce(m, 'tilesloaded', function() { cb(); });
        }
        ,
    'com.rapido.maps.kmp.interop.setMapCameraImpl' : 
        (m, lat, lng, zoom, tilt, bearing) => {
            m.moveCamera({
                center: { lat: lat, lng: lng },
                zoom: zoom,
                tilt: tilt,
                heading: bearing
            });
        }
        ,
    'com.rapido.maps.kmp.interop.fitBoundsImpl' : 
        (m, boundsJson, padding) => {
            var arr = JSON.parse(boundsJson);
            var bounds = new google.maps.LatLngBounds();
            arr.forEach(function(p) { bounds.extend({ lat: p.lat, lng: p.lng }); });
            m.fitBounds(bounds, padding);
        }
        ,
    'com.rapido.maps.kmp.interop.clearMarkersImpl' : 
        (arr) => {
            for (var i = 0; i < arr.length; i++) { arr[i].setMap(null); }
            arr.length = 0;
        }
        ,
    'com.rapido.maps.kmp.interop.addMarkerImpl' : 
        (m, arr, lat, lng, title, iconUrl, w, h, anchorX, anchorY, rotation, alpha, zIdx, visible, clickCb) => {
            var opts = {
                position: { lat: lat, lng: lng },
                map: m,
                title: title,
                opacity: alpha,
                zIndex: zIdx,
                visible: visible
            };
            if (iconUrl && iconUrl.length > 0) {
                opts.icon = {
                    url: iconUrl,
                    scaledSize: new google.maps.Size(w, h),
                    anchor: new google.maps.Point(w * anchorX, h * anchorY)
                };
            }
            var marker = new google.maps.Marker(opts);
            if (clickCb) {
                marker.addListener('click', function() { clickCb(); });
            }
            arr.push(marker);
            return marker;
        }
        ,
    'com.rapido.maps.kmp.interop.clearPolylinesImpl' : 
        (arr) => {
            for (var i = 0; i < arr.length; i++) { arr[i].setMap(null); }
            arr.length = 0;
        }
        ,
    'com.rapido.maps.kmp.interop.addPolylineImpl' : 
        (m, arr, pathJson, color, width, zIdx, geodesic, visible, patternJson) => {
            var path = JSON.parse(pathJson);
            var pattern = (patternJson && patternJson.length > 2) ? JSON.parse(patternJson) : [];

            var polylineOpts = {
                path: path,
                strokeColor: color,
                strokeOpacity: 1.0,
                strokeWeight: width,
                zIndex: zIdx,
                geodesic: geodesic,
                visible: visible,
                map: m
            };

            if (pattern.length > 0) {
                polylineOpts.strokeOpacity = 0;
                var cycle = 0;
                for (var i = 0; i < pattern.length; i++) cycle += pattern[i].len;
                var icons = [];
                var offset = 0;
                for (var i = 0; i < pattern.length; i++) {
                    var item = pattern[i];
                    if (item.type === 'gap') { offset += item.len; continue; }
                    var symbol;
                    if (item.type === 'dot') {
                        symbol = {
                            path: google.maps.SymbolPath.CIRCLE,
                            scale: width / 2,
                            fillColor: color,
                            fillOpacity: 1,
                            strokeOpacity: 0
                        };
                    } else {
                        symbol = {
                            path: 'M 0,-1 0,1',
                            strokeColor: color,
                            strokeOpacity: 1,
                            strokeWeight: width,
                            scale: item.len / 2
                        };
                    }
                    icons.push({
                        icon: symbol,
                        offset: cycle > 0 ? (((offset / cycle) * 100).toFixed(1) + '%') : '0%',
                        repeat: cycle + 'px'
                    });
                    offset += item.len;
                }
                if (icons.length > 0) polylineOpts.icons = icons;
            }

            var polyline = new google.maps.Polyline(polylineOpts);
            arr.push(polyline);
            return polyline;
        }
        ,
    'com.rapido.maps.kmp.interop.setMapStyleImpl' : 
        (m, json) => {
            try { m.setOptions({ styles: JSON.parse(json) }); }
            catch(e) { console.warn('Failed to apply map style:', e); }
        }
        ,
    'com.rapido.maps.kmp.interop.clearMapStyleImpl' : (m) => { m.setOptions({ styles: null }); },
    'com.rapido.maps.kmp.interop.destroyMapImpl' : (m) => { google.maps.event.clearInstanceListeners(m); },
    'com.rapido.maps.kmp.interop.createOverlayProjectorImpl' : 
        (m, lat, lng, cb) => {
            function OverlayProjector(p, callback) {
                this.position = p;
                this.callback = callback;
            }
            OverlayProjector.prototype = new google.maps.OverlayView();
            OverlayProjector.prototype.onAdd = function() {};
            OverlayProjector.prototype.onRemove = function() {};
            OverlayProjector.prototype.draw = function() {
                var proj = this.getProjection();
                if (!proj) return;
                var p = proj.fromLatLngToContainerPixel(
                    new google.maps.LatLng(this.position.lat, this.position.lng)
                );
                if (p) this.callback(p.x, p.y);
            };
            OverlayProjector.prototype.setPosition = function(lat, lng) {
                this.position = { lat: lat, lng: lng };
                this.draw();
            };
            var ov = new OverlayProjector({ lat: lat, lng: lng }, cb);
            ov.setMap(m);
            return ov;
        }
        ,
    'com.rapido.maps.kmp.interop.__convertKotlinClosureToJsClosure_((Double,Double)->Unit)' : (f) => getCachedJsObject(f, (p0, p1) => wasmExports['__callFunction_((Double,Double)->Unit)'](f, p0, p1)),
    'com.rapido.maps.kmp.interop.removeOverlayProjectorImpl' : (ov) => { ov.setMap(null); },
    'com.rapido.maps.kmp.interop.setOverlayProjectorPositionImpl' : (ov, lat, lng) => { ov.setPosition(lat, lng); },
    'com.rapido.maps.kmp.interop.createStreetViewPanoramaImpl' : 
        (element, lat, lng, heading, pitch, sourceStr, motionTracking) => {
            var src = (sourceStr === 'OUTDOOR') ? google.maps.StreetViewSource.OUTDOOR : google.maps.StreetViewSource.DEFAULT;
            var pano = new google.maps.StreetViewPanorama(element, {
                position: { lat: lat, lng: lng },
                pov: { heading: heading, pitch: pitch },
                source: src,
                motionTracking: motionTracking,
                motionTrackingControl: motionTracking,
                addressControl: false,
                fullscreenControl: false,
                linksControl: true,
                panControl: true,
                zoomControl: true,
                enableCloseButton: false
            });
            return pano;
        }
        ,
    'com.rapido.maps.kmp.interop.addStreetViewListenersImpl' : 
        (pano, onPos, onPov, onLoad, onErr) => {
            google.maps.event.addListener(pano, 'position_changed', function() {
                var pos = pano.getPosition();
                if (pos) onPos(pos.lat(), pos.lng());
            });
            google.maps.event.addListener(pano, 'pov_changed', function() {
                var pov = pano.getPov();
                onPov(pov.heading, pov.pitch);
            });
            google.maps.event.addListener(pano, 'status_changed', function() {
                var status = pano.getStatus();
                if (status === 'OK' || status === google.maps.StreetViewStatus.OK) {
                    onLoad();
                } else {
                    onErr('Street View status: ' + status);
                }
            });
        }
        ,
    'com.rapido.maps.kmp.interop.setStreetViewPovImpl' : (pano, h, p) => { pano.setPov({ heading: h, pitch: p }); },
    'com.rapido.maps.kmp.interop.getPanoramaPitchImpl' : (pano) => { var pov = pano.getPov(); return pov ? pov.pitch : 0; },
    'com.rapido.maps.kmp.interop.removeMarkerImpl' : (marker) => { marker.setMap(null); },
    'com.rapido.maps.kmp.interop.addStreetViewMarkerImpl' : 
        (pano, lat, lng, iconUrl, w, h) => {
            var opts = { position: { lat: lat, lng: lng }, map: pano };
            if (iconUrl && iconUrl.length > 0) {
                opts.icon = { url: iconUrl, scaledSize: new google.maps.Size(w, h) };
            }
            return new google.maps.Marker(opts);
        }
        ,
    'com.rapido.maps.kmp.interop.setStreetViewPositionImpl' : (pano, lat, lng) => { pano.setPosition({ lat: lat, lng: lng }); },
    'com.rapido.maps.kmp.interop.destroyStreetViewImpl' : (pano) => { google.maps.event.clearInstanceListeners(pano); },
    'com.rapido.maps.kmp.interop.pixelDataToDataUrlImpl' : 
        (base64Rgba, width, height) => {
            var binary = atob(base64Rgba);
            var bytes = new Uint8ClampedArray(binary.length);
            for (var i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
            var canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            var ctx = canvas.getContext('2d');
            ctx.putImageData(new ImageData(bytes, width, height), 0, 0);
            return canvas.toDataURL('image/png');
        }
        ,
    'com.rapido.maps.kmp.interop.isGoogleMapsLoadedJs' : () => typeof google !== 'undefined' && typeof google.maps !== 'undefined',
    'com.rapido.maps.kmp.interop.injectGoogleMapsScript' : 
        (apiKey) => {
            var s = document.createElement('script');
            s.src = 'https://maps.googleapis.com/maps/api/js?key=' + apiKey + '&libraries=geometry';
            s.async = true;
            s.defer = true;
            document.head.appendChild(s);
        }
        ,
    'com.rapido.locationkmp.internal.data.source.local.location.isGeolocationSupported' : () => typeof navigator !== 'undefined' && 'geolocation' in navigator,
    'com.rapido.locationkmp.internal.data.source.local.location.getGeolocationErrorCode' : (err) => err.code,
    'com.rapido.locationkmp.internal.data.source.local.location.getGeolocationErrorMessage' : (err) => err.message || 'Unknown geolocation error',
    'com.rapido.locationkmp.internal.data.source.local.location.getPositionLatitude' : (pos) => pos.coords.latitude,
    'com.rapido.locationkmp.internal.data.source.local.location.getPositionLongitude' : (pos) => pos.coords.longitude,
    'com.rapido.locationkmp.internal.data.source.local.location.getPositionAccuracy' : (pos) => pos.coords.accuracy,
    'com.rapido.locationkmp.internal.data.source.local.location.getPositionSpeed' : (pos) => pos.coords.speed || 0,
    'com.rapido.locationkmp.internal.data.source.local.location.getPositionHeading' : (pos) => pos.coords.heading || 0,
    'com.rapido.locationkmp.internal.data.source.local.location.getPositionTimestamp' : (pos) => pos.timestamp,
    'com.rapido.locationkmp.internal.data.source.local.location.browserGetCurrentPositionImpl' : (s, e, ha, t, ma) => navigator.geolocation.getCurrentPosition(s, e, {enableHighAccuracy: ha, timeout: t, maximumAge: ma}),
    'com.rapido.location_sync_kmp.data.location.isGeolocationSupported' : () => typeof navigator !== 'undefined' && 'geolocation' in navigator,
    'com.rapido.location_sync_kmp.data.location.getGeolocationErrorCode' : (err) => err.code,
    'com.rapido.location_sync_kmp.data.location.getGeolocationErrorMessage' : (err) => err.message || 'Unknown geolocation error',
    'com.rapido.location_sync_kmp.data.location.getPositionLatitude' : (pos) => pos.coords.latitude,
    'com.rapido.location_sync_kmp.data.location.getPositionLongitude' : (pos) => pos.coords.longitude,
    'com.rapido.location_sync_kmp.data.location.getPositionAccuracy' : (pos) => pos.coords.accuracy,
    'com.rapido.location_sync_kmp.data.location.getPositionSpeed' : (pos) => pos.coords.speed || 0,
    'com.rapido.location_sync_kmp.data.location.getPositionHeading' : (pos) => pos.coords.heading || 0,
    'com.rapido.location_sync_kmp.data.location.getPositionTimestamp' : (pos) => pos.timestamp,
    'com.rapido.location_sync_kmp.data.location.browserGetCurrentPositionImpl' : (s, e, ha, t, ma) => navigator.geolocation.getCurrentPosition(s, e, {enableHighAccuracy: ha, timeout: t, maximumAge: ma}),
    'com.rapido.chat.kmp.data.interop.getAppImpl' : (name) => firebase.app(name),
    'com.rapido.chat.kmp.data.interop.initializeAppWithNameImpl' : 
        (configJson, name) => {
            var config = JSON.parse(configJson);
            return firebase.initializeApp(config, name);
        }
        ,
    'com.rapido.chat.kmp.data.interop.getAuthImpl' : (app) => firebase.auth(app),
    'com.rapido.chat.kmp.data.interop.signInAnonymouslyImpl' : 
        (auth, onSuccess, onError) => {
            auth.signInAnonymously()
                .then(result => {
                    onSuccess(
                        result.user ? result.user.uid : '',
                        result.user ? result.user.isAnonymous : true
                    );
                })
                .catch(error => {
                    onError(error.message || 'Unknown auth error');
                });
        }
        ,
    'com.rapido.chat.kmp.data.interop.__convertKotlinClosureToJsClosure_((String,Boolean)->Unit)' : (f) => getCachedJsObject(f, (p0, p1) => wasmExports['__callFunction_((String,Boolean)->Unit)'](f, p0, p1)),
    'com.rapido.chat.kmp.data.interop.isUserSignedInImpl' : (auth) => auth.currentUser !== null,
    'com.rapido.chat.kmp.data.interop.getCurrentUserUidImpl' : (auth) => auth.currentUser ? auth.currentUser.uid : '',
    'com.rapido.chat.kmp.data.interop.isFirebaseLoadedJs' : 
        () => typeof firebase !== 'undefined'
             && typeof firebase.auth !== 'undefined'
             && typeof firebase.firestore !== 'undefined'
             && typeof firebase.database !== 'undefined'
        ,
    'com.rapido.chat.kmp.data.interop.injectFirebaseScript' : 
        (url) => {
            var s = document.createElement('script');
            s.src = url;
            s.async = false;
            document.head.appendChild(s);
        }
        ,
    'com.rapido.chat.kmp.data.interop.firestoreCollectionImpl' : (firestore, path) => firestore.collection(path),
    'com.rapido.chat.kmp.data.interop.addDocumentImpl' : 
        (collectionRef, dataJson, onSuccess, onError) => {
            var data = JSON.parse(dataJson);
            collectionRef.add(data).then(() => onSuccess()).catch(e => onError(e.message));
        }
        ,
    'com.rapido.chat.kmp.data.interop.setDocumentImpl' : 
        (docRef, dataJson, onSuccess, onError) => {
            var data = JSON.parse(dataJson);
            docRef.set(data).then(() => onSuccess()).catch(e => onError(e.message));
        }
        ,
    'com.rapido.chat.kmp.data.interop.firestoreDocImpl' : (collectionRef, docId) => collectionRef.doc(docId),
    'com.rapido.chat.kmp.data.interop.deleteDocumentImpl' : 
        (docRef, onSuccess, onError) => {
            docRef.delete().then(() => onSuccess()).catch(e => onError(e.message));
        }
        ,
    'com.rapido.chat.kmp.data.interop.queryOrderByLimitImpl' : (collRef, field, direction, limitCount) => collRef.orderBy(field, direction).limit(limitCount),
    'com.rapido.chat.kmp.data.interop.onSnapshotImpl' : 
        (query, onNext, onError) => {
            return query.onSnapshot(snapshot => onNext(snapshot), error => onError(error.message));
        }
        ,
    'com.rapido.chat.kmp.data.interop.getDocsArrayImpl' : (snapshot) => snapshot.docs,
    'com.rapido.chat.kmp.data.interop.getArrayLengthImpl' : (arr) => arr.length,
    'com.rapido.chat.kmp.data.interop.getArrayElementImpl' : (arr, index) => arr[index],
    'com.rapido.chat.kmp.data.interop.getDocumentDataJsonImpl' : (doc) => JSON.stringify(doc.data()),
    'com.rapido.chat.kmp.data.interop.getDocumentIdImpl' : (doc) => doc.id,
    'com.rapido.chat.kmp.data.interop.createWriteBatchImpl' : (firestore) => firestore.batch(),
    'com.rapido.chat.kmp.data.interop.batchUpdateImpl' : (batch, docRef, dataJson) => { batch.update(docRef, JSON.parse(dataJson)); },
    'com.rapido.chat.kmp.data.interop.commitBatchImpl' : 
        (batch, onSuccess, onError) => {
            batch.commit().then(() => onSuccess()).catch(e => onError(e.message));
        }
        ,
    'com.rapido.chat.kmp.data.interop.updateDocumentImpl' : 
        (docRef, dataJson, onSuccess, onError) => {
            var data = JSON.parse(dataJson);
            docRef.update(data).then(() => onSuccess()).catch(e => onError(e.message));
        }
        ,
    'com.rapido.chat.kmp.data.interop.getFirestoreWithDbImpl' : 
        (app, databaseId) => {
            // Route to default Firestore when no explicit database id is requested.
            if (!databaseId || databaseId === "(default)") {
                return app.firestore();
            }

            // Compat static API for named DB, if available in current runtime.
            if (typeof firebase !== "undefined" && firebase && typeof firebase.firestore === "function") {
                try {
                    return firebase.firestore(app, databaseId);
                } catch (_) {}
            }

            // Fallback for runtimes exposing app.firestore(databaseId).
            try {
                return app.firestore(databaseId);
            } catch (_) {
                return app.firestore();
            }
        }
        ,
    'com.rapido.chat.kmp.data.interop.getDatabaseRefImpl' : (db, path) => db.ref(path),
    'com.rapido.chat.kmp.data.interop.pushRefImpl' : (ref) => ref.push(),
    'com.rapido.chat.kmp.data.interop.setValueImpl' : 
        (ref, dataJson, onSuccess, onError) => {
            var data = JSON.parse(dataJson);
            ref.set(data).then(() => onSuccess()).catch(e => onError(e.message));
        }
        ,
    'com.rapido.chat.kmp.data.interop.updateChildrenImpl' : 
        (ref, dataJson, onSuccess, onError) => {
            var data = JSON.parse(dataJson);
            ref.update(data).then(() => onSuccess()).catch(e => onError(e.message));
        }
        ,
    'com.rapido.chat.kmp.data.interop.onValueImpl' : (ref, callback) => ref.on('value', snapshot => callback(snapshot)),
    'com.rapido.chat.kmp.data.interop.getSnapshotChildrenImpl' : 
        (snapshot) => {
            var children = [];
            snapshot.forEach(child => {
                children.push(child);
                return false;
            });
            return children;
        }
        ,
    'com.rapido.chat.kmp.data.interop.getChildKeyImpl' : (snapshot) => snapshot.key,
    'com.rapido.chat.kmp.data.interop.getChildValJsonImpl' : (snapshot) => JSON.stringify(snapshot.val()),
    'com.rapido.chat.kmp.data.interop.offValueImpl' : (ref, listener) => { ref.off('value', listener); },
    'com.rapido.chat.kmp.data.interop.goOfflineImpl' : (db) => { db.goOffline(); },
    'com.rapido.chat.kmp.data.interop.getDatabaseImpl' : (app, url) => app.database(url),
    'com.rapido.chat.kmp.data.interop.goOnlineImpl' : (db) => { db.goOnline(); },
    'com.rapido.soundbites.data.platform.audio.isMediaRecorderAvailableImpl' : () => typeof navigator !== 'undefined' && !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia) && typeof MediaRecorder !== 'undefined',
    'com.rapido.soundbites.data.platform.audio.createRecorderSessionImpl' : 
        (mimeType, onSuccess, onError) => {
            try {
                if (typeof navigator === 'undefined' || !navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
                    onError('Microphone API is not available in this browser');
                    return;
                }
                if (typeof MediaRecorder === 'undefined') {
                    onError('MediaRecorder is not supported in this browser');
                    return;
                }
                navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
                    try {
                        var options = mimeType ? { mimeType: mimeType } : undefined;
                        var recorder = options ? new MediaRecorder(stream, options) : new MediaRecorder(stream);
                        recorder.__soundbitesChunks = [];
                        recorder.ondataavailable = event => {
                            if (event && event.data && event.data.size > 0) {
                                recorder.__soundbitesChunks.push(event.data);
                            }
                        };
                        recorder.onerror = event => {
                            var message = event && event.error && event.error.message
                                ? event.error.message
                                : 'Audio recorder encountered an error';
                            onError(message);
                        };
                        onSuccess(recorder, stream, recorder.mimeType || mimeType || 'audio/mp4');
                    } catch (error) {
                        try {
                            if (stream && stream.getTracks) {
                                stream.getTracks().forEach(track => {
                                    try { track.stop(); } catch (_) { }
                                });
                            }
                        } catch (_) { }
                        onError(error && error.message ? error.message : 'Failed to create MediaRecorder');
                    }
                }).catch(error => {
                    var name = error && error.name ? error.name : 'UnknownError';
                    var message = error && error.message ? error.message : 'Unable to access microphone';
                    onError(name + ': ' + message);
                });
            } catch (error) {
                onError(error && error.message ? error.message : 'Failed to initialize microphone');
            }
        }
        ,
    'com.rapido.soundbites.data.platform.audio.__convertKotlinClosureToJsClosure_((Js,Js,String)->Unit)' : (f) => getCachedJsObject(f, (p0, p1, p2) => wasmExports['__callFunction_((Js,Js,String)->Unit)'](f, p0, p1, p2)),
    'com.rapido.soundbites.data.platform.audio.startRecorderImpl' : 
        (recorder) => {
            if (!recorder) return;
            if (!recorder.__soundbitesChunks) {
                recorder.__soundbitesChunks = [];
            }
            recorder.start(120);
        }
        ,
    'com.rapido.soundbites.data.platform.audio.nowEpochMillisImpl' : () => Date.now(),
    'com.rapido.soundbites.data.platform.audio.releaseRecorderSessionImpl' : 
        (recorder, stream) => {
            try {
                if (recorder) {
                    recorder.ondataavailable = null;
                    recorder.onstop = null;
                    recorder.onerror = null;
                }
            } catch (_) { }
            try {
                if (stream && stream.getTracks) {
                    stream.getTracks().forEach(track => {
                        try { track.stop(); } catch (_) { }
                    });
                }
            } catch (_) { }
        }
        ,
    'com.rapido.soundbites.data.platform.audio.stopRecorderSessionImpl' : 
        (recorder, stream, onSuccess, onError) => {
            if (!recorder) {
                onError('Recorder is not initialized');
                return;
            }
            var finished = false;
            var finalize = () => {
                if (finished) return;
                finished = true;
                try {
                    var chunks = recorder.__soundbitesChunks || [];
                    if (!chunks.length) {
                        onError('No audio data captured');
                        return;
                    }
                    var mimeType = recorder.mimeType || (chunks[0] && chunks[0].type) || 'audio/mp4';
                    var blob = new Blob(chunks, { type: mimeType });
                    var reader = new FileReader();
                    reader.onloadend = () => {
                        var dataUrl = '' + (reader.result || '');
                        var comma = dataUrl.indexOf(',');
                        var base64Data = comma >= 0 ? dataUrl.substring(comma + 1) : '';
                        if (!base64Data) {
                            onError('Failed to extract audio bytes');
                            return;
                        }
                        onSuccess(base64Data, mimeType);
                    };
                    reader.onerror = () => onError('Failed to read recorded audio');
                    reader.readAsDataURL(blob);
                } catch (error) {
                    onError(error && error.message ? error.message : 'Failed to finalize recording');
                } finally {
                    try {
                        if (stream && stream.getTracks) {
                            stream.getTracks().forEach(track => {
                                try { track.stop(); } catch (_) { }
                            });
                        }
                    } catch (_) { }
                    recorder.ondataavailable = null;
                    recorder.onstop = null;
                    recorder.onerror = null;
                }
            };
            try {
                recorder.onstop = finalize;
                if (recorder.state === 'inactive') {
                    finalize();
                    return;
                }
                recorder.stop();
            } catch (error) {
                onError(error && error.message ? error.message : 'Failed to stop recording');
            }
        }
        ,
    'com.rapido.soundbites.data.platform.audio.__convertKotlinClosureToJsClosure_((String,String)->Unit)' : (f) => getCachedJsObject(f, (p0, p1) => wasmExports['__callFunction_((String,String)->Unit)'](f, p0, p1)),
    'com.rapido.soundbites.data.platform.audio.createAudioElementImpl' : 
        (source) => {
            var audio = new Audio();
            audio.preload = 'auto';
            audio.src = source;
            return audio;
        }
        ,
    'com.rapido.soundbites.data.platform.audio.bindAudioPlayerCallbacksImpl' : 
        (audio, onLoaded, onProgress, onEnded, onError) => {
            if (!audio) return;
            audio.onloadedmetadata = () => {
                onLoaded((audio.duration || 0) * 1000);
            };
            audio.ontimeupdate = () => {
                onProgress((audio.currentTime || 0) * 1000, (audio.duration || 0) * 1000);
            };
            audio.onended = () => onEnded();
            audio.onerror = () => {
                var message = (audio.error && audio.error.message) ? audio.error.message : 'Audio playback failed';
                onError(message);
            };
        }
        ,
    'com.rapido.soundbites.data.platform.audio.playAudioElementImpl' : 
        (audio, onSuccess, onError) => {
            if (!audio) {
                onError('Audio player is not initialized');
                return;
            }
            try {
                var playResult = audio.play();
                if (playResult && typeof playResult.then === 'function') {
                    playResult.then(() => onSuccess()).catch(error => {
                        onError(error && error.message ? error.message : 'Playback failed');
                    });
                } else {
                    onSuccess();
                }
            } catch (error) {
                onError(error && error.message ? error.message : 'Playback failed');
            }
        }
        ,
    'com.rapido.soundbites.data.platform.audio.pauseAudioElementImpl' : 
        (audio) => {
            if (!audio) return;
            try {
                audio.pause();
            } catch (_) { }
        }
        ,
    'com.rapido.soundbites.data.platform.audio.resumeAudioElementImpl' : 
        (audio, onSuccess, onError) => {
            if (!audio) {
                onError('Audio player is not initialized');
                return;
            }
            try {
                var playResult = audio.play();
                if (playResult && typeof playResult.then === 'function') {
                    playResult.then(() => onSuccess()).catch(error => {
                        onError(error && error.message ? error.message : 'Failed to resume playback');
                    });
                } else {
                    onSuccess();
                }
            } catch (error) {
                onError(error && error.message ? error.message : 'Failed to resume playback');
            }
        }
        ,
    'com.rapido.soundbites.data.platform.audio.isMimeTypeSupportedImpl' : 
        (mimeType) => {
            try {
                if (typeof MediaRecorder === 'undefined' || typeof MediaRecorder.isTypeSupported !== 'function') {
                    return false;
                }
                return MediaRecorder.isTypeSupported(mimeType);
            } catch (_) {
                return false;
            }
        }
        ,
    'com.rapido.soundbites.data.platform.audio.createBlobUrlFromBase64Impl' : 
        (base64Data, mimeType) => {
            try {
                var binary = atob(base64Data || '');
                var len = binary.length;
                var bytes = new Uint8Array(len);
                for (var i = 0; i < len; i++) {
                    bytes[i] = binary.charCodeAt(i);
                }
                var blob = new Blob([bytes], { type: mimeType || 'audio/mp4' });
                return URL.createObjectURL(blob);
            } catch (_) {
                return '';
            }
        }
        ,
    'com.rapido.soundbites.data.platform.audio.stopAudioElementImpl' : 
        (audio) => {
            if (!audio) return;
            try {
                audio.pause();
                audio.currentTime = 0;
            } catch (_) { }
        }
        ,
    'com.rapido.soundbites.data.platform.audio.releaseAudioElementImpl' : 
        (audio) => {
            if (!audio) return;
            try {
                audio.pause();
            } catch (_) { }
            audio.onloadedmetadata = null;
            audio.ontimeupdate = null;
            audio.onended = null;
            audio.onerror = null;
            try {
                audio.src = '';
            } catch (_) { }
        }
        ,
    'com.rapido.soundbites.data.platform.audio.revokeBlobUrlImpl' : 
        (blobUrl) => {
            try {
                URL.revokeObjectURL(blobUrl);
            } catch (_) { }
        }
        ,
    'com.rapido.attachment.picker.kmp.picker.openFilePickerJs' : 
      (accept, multiple, onFiles, onError) => {
          var input = document.createElement('input');
          input.type = 'file';
          input.accept = accept;
          input.multiple = multiple;
          input.style.display = 'none';
          document.body.appendChild(input);
          input.onchange = function(e) {
              var files = e.target.files;
              document.body.removeChild(input);
              if (!files || files.length === 0) {
                  onError('No files selected');
                  return;
              }
              var urls = [];
              for (var i = 0; i < files.length; i++) {
                  urls.push(URL.createObjectURL(files[i]));
              }
              onFiles(urls.join('|'));
          };
          input.click();
      }
      ,
    'com.rapido.attachment.picker.kmp.picker.jsToKotlinString' : (value) => '' + value,
    'com.rapido.chat.kmp.sdk.data.location.isGeolocationAvailable' : () => typeof navigator !== 'undefined' && navigator.geolocation != null,
    'com.rapido.chat.kmp.sdk.data.location.watchPosition' : 
        (onSuccess, onError) => {
            return navigator.geolocation.watchPosition(
                pos => onSuccess(pos.coords.latitude, pos.coords.longitude, pos.coords.accuracy || 0.0),
                err => onError(err.message || 'Geolocation error'),
                { enableHighAccuracy: true, maximumAge: 0, timeout: 10000 }
            );
        }
        ,
    'com.rapido.chat.kmp.sdk.data.location.__convertKotlinClosureToJsClosure_((Double,Double,Double)->Unit)' : (f) => getCachedJsObject(f, (p0, p1, p2) => wasmExports['__callFunction_((Double,Double,Double)->Unit)'](f, p0, p1, p2)),
    'com.rapido.chat.kmp.sdk.data.location.clearWatch' : (id) => { navigator.geolocation.clearWatch(id); },
    'mobi.stratus.pool.camera.attachPreviewElement' : () => { 
        {
          if (!globalThis.hoprCamera) globalThis.hoprCamera = {};
          var cam = globalThis.hoprCamera;
          if (cam.video) return;
          var video = document.createElement('video');
          video.setAttribute('autoplay', 'true');
          video.setAttribute('playsinline', 'true');
          video.muted = true;
          video.style.position = 'fixed';
          video.style.objectFit = 'cover';
          video.style.borderRadius = '50%';
          video.style.transform = 'scaleX(-1)';
          video.style.pointerEvents = 'none';
          video.style.zIndex = '20';
          video.style.visibility = 'hidden';
          if (document.body) document.body.appendChild(video);
          cam.video = video;
        }
         },
    'mobi.stratus.pool.camera.layoutPreview' : (left, top, width, height) => { 
        {
          var video = globalThis.hoprCamera && globalThis.hoprCamera.video;
          if (!video) return;
          video.style.left = left + 'px';
          video.style.top = top + 'px';
          video.style.width = width + 'px';
          video.style.height = height + 'px';
          video.style.visibility = 'visible';
        }
         },
    'mobi.stratus.pool.camera.releasePreviewElement' : () => { 
        {
          var cam = globalThis.hoprCamera;
          if (!cam) return;
          if (cam.stream) {
            cam.stream.getTracks().forEach(function(track) { track.stop(); });
            cam.stream = null;
          }
          if (cam.video) {
            cam.video.srcObject = null;
            if (cam.video.parentNode) cam.video.parentNode.removeChild(cam.video);
            cam.video = null;
          }
        }
         },
    'mobi.stratus.pool.camera.previewHasFrame' : () => (!!(globalThis.hoprCamera && globalThis.hoprCamera.video && globalThis.hoprCamera.video.videoWidth > 0)),
    'mobi.stratus.pool.camera.captureJpeg' : (quality) => 
      (function() {
        var cam = globalThis.hoprCamera;
        var video = cam && cam.video;
        if (!video || !video.videoWidth) return '';
        var canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        var ctx = canvas.getContext('2d');
        ctx.translate(canvas.width, 0);
        ctx.scale(-1, 1);
        ctx.drawImage(video, 0, 0);
        return canvas.toDataURL('image/jpeg', quality);
      })()
      ,
    'mobi.stratus.pool.camera.startPreview' : (onReady, onFailed) => { 
        {
          var cam = globalThis.hoprCamera;
          var video = cam && cam.video;
          if (!video) {
            onFailed('Camera preview is not ready');
          } else if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
            onFailed('Camera is not available in this browser');
          } else {
            navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user' }, audio: false })
              .then(function(stream) {
                if (cam.video !== video) {
                  stream.getTracks().forEach(function(track) { track.stop(); });
                  throw new Error('Camera preview was closed');
                }
                if (cam.stream && cam.stream !== stream) {
                  cam.stream.getTracks().forEach(function(track) { track.stop(); });
                }
                cam.stream = stream;
                video.srcObject = stream;
                return video.play();
              })
              .then(function() { onReady(); })
              .catch(function(error) {
                onFailed(String((error && error.message) || error));
              });
          }
        }
         },
    'mobi.stratus.pool.config.initialize_$external_fun' : (_this, p0, p1, p2, p3, p4, p5, p6) => _this.initialize(p0, p1, p2, p3, p4, p5, p6),
    'mobi.stratus.pool.config.fetchAndActivate_$external_fun' : (_this, p0) => _this.fetchAndActivate(p0),
    'mobi.stratus.pool.config.__convertKotlinClosureToJsClosure_((Boolean)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Boolean)->Unit)'](f, p0)),
    'mobi.stratus.pool.config.getString_$external_fun' : (_this, p0) => _this.getString(p0),
    'mobi.stratus.pool.config.getBoolean_$external_fun' : (_this, p0) => _this.getBoolean(p0),
    'mobi.stratus.pool.config.getNumber_$external_fun' : (_this, p0) => _this.getNumber(p0),
    'mobi.stratus.pool.config.FirebaseConfigBridge_$external_object_getInstance' : () => FirebaseConfigBridge,
    'mobi.stratus.pool.preloader.hidePwaPreloader' : () => { typeof window.hidePwaLoader === 'function' && window.hidePwaLoader() }
}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export { wasmTag as __TAG };

export const importObject = {
    js_code,
    intrinsics: {
        tag: wasmTag
    },
    "'": StringConstantsProxy,
    'wasm:js-string': d2FzbTpqcy1zdHJpbmc,
    './skiko.mjs': Li9za2lrby5tanM,
};
    